<template>
  <q-field
    :model-value="modelValue"
    :hint="hint"
    :error="!!errorMessage"
    :error-message="errorMessage"
    borderless
    hide-bottom-space
    dense
  >
    <StatusSelector
      clickable
      :label="fieldName"
      :hex-color="fieldColor"
    >
      <responsive-menu
        force-on-mobile
        toolbar-title="Appointment Status"
        card-style="width: 300px;"
      >
        <q-list dense>
          <q-item
            v-for="(status, key) in filterStatusOptions"
            :key="key"
            v-ripple
            tag="label"
          >
            <q-item-section>
              <q-radio
                v-close-popup
                :model-value="modelValue"
                class="color-inherit"
                :label="status.label"
                :val="status.value"
                :style="{'color': status.hex_color}"
                @update:model-value="(val) => $emit('update:modelValue', val)"
              />
            </q-item-section>
          </q-item>
        </q-list>
      </responsive-menu>
    </StatusSelector>
  </q-field>
</template>

<script>
import statusMixin from '../mixins/statusMixin'
import StatusSelector from 'components/partials/StatusSelector'

/**
 * Simple "input" variant for selecting a status without automatically saving changes.
 */
export default {
  components: {
    StatusSelector
  },
  mixins: [statusMixin],
  props: {
    modelValue: {
      type: String,
      required: true
    },
    edit: {
      type: Boolean,
      default: false
    },
    hint: {
      type: String
    },
    errorMessage: {
      type: String
    },
    customSet: {
      type: Array,
      default: null
    }
  },
  emits: ['update:modelValue'],
  data () {
    return {
      timer: null,
      showNote: false
    }
  },
  computed: {
    filterStatusOptions () {
      if (this.customSet) {
        return this.baseStatusOptions().filter(item => this.customSet.includes(item.value))
      }
      if (this.edit) {
        return this.baseStatusOptions()
      }
      return this.baseStatusOptions().filter(item => ['UNSCHEDULED', 'SCHEDULED', 'UNCONFIRMED'].includes(item.value))
    },
    fieldColor () {
      return this.baseFieldColor(this.modelValue)
    },
    fieldName () {
      return this.baseFieldName(this.modelValue)
    }
  }
}
</script>
